export default __webpack_public_path__ + "static/media/newsLandingBanner.f504833c.png";